var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSystem = function SvgSystem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.16 1.947a2.35 2.35 0 0 1 1.596-.614h11.488c.598 0 1.172.221 1.595.614s.661.926.661 1.482v6.857c0 .555-.238 1.088-.66 1.481a2.35 2.35 0 0 1-1.596.614H9.115v1.143h1.846c.34 0 .616.256.616.571 0 .316-.276.572-.616.572H6.038c-.34 0-.615-.256-.615-.572s.276-.571.615-.571h1.847V12.38H2.756c-.598 0-1.172-.22-1.595-.614A2.02 2.02 0 0 1 .5 10.286V3.429c0-.556.238-1.09.66-1.482m1.596.53c-.272 0-.532.1-.725.278a.92.92 0 0 0-.3.674v6.857a.92.92 0 0 0 .3.673c.193.179.453.28.725.28h11.488c.272 0 .533-.101.725-.28.192-.178.3-.42.3-.673V3.429a.92.92 0 0 0-.3-.674 1.07 1.07 0 0 0-.725-.279z",
    clipRule: "evenodd"
  })));
};
export default SvgSystem;